import { Spin } from "antd";
import * as React from "react";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { ICaseDecisionUpdatePresenter } from "../../presenter/CaseDecisionUpdatePresenter";
import CaseDecisionUpdateForm from "../components/CaseDecisionUpdateForm";

export interface Props extends PageProps {}
export interface State extends ICaseDecisionUpdatePresenter {}

export default class CaseDecisionUpdatePage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      caseDecision,
      organisations,
      caseDecisionTypes,
      attachmentTypes,
      contentTypes,
      attachmentList,
      uploadedFile,
      indexHierarchyList,
      courtCase,
      createAttachment,
      setFileValue,
      updateAttachment,
      updateMainAttachment,
      setAttachmentType,
      deleteAttachment,
      showCaseDecisionDetailsPage,
      updateCaseDecision,
      mainAttachment,
      toggleAttachementModal,
      attachmentModalVisible,
      canEdit,
      anonimisedUploadedFile,
      setAnonymisedFileValue,
      parentGroupList,
      secondGroupList,
      selectedIndexes,
      selectedParentGroupIdList,
      selectedSecondGroupIdList,
      setParentGroupId,
      setSecondGroupId,
      organisationIndexes,
      publishCaseDecision,
      setMainAttachmentType,
      indexTypeAttributes,
      setAttributesData,
      indexAttributeDataList,
      closeIndexDataModal,
      openIndexDataModal,
      indexDataModalVisible,
      saveAttributeData,
      selectedIndexForAttribute
    } = this.state;
    return (
      <Page {...this.props} className={"page-wrapper"}>
        <CaseDecisionUpdateForm
          translate={translate}
          caseDecision={caseDecision}
          organisations={organisations}
          caseDecisionTypes={caseDecisionTypes}
          attachmentTypes={attachmentTypes}
          contentTypes={contentTypes}
          attachmentList={attachmentList}
          uploadedFile={uploadedFile}
          indexHierarchyList={indexHierarchyList}
          createAttachment={createAttachment}
          setFileValue={setFileValue}
          updateAttachment={updateAttachment}
          updateMainAttachment={updateMainAttachment}
          setAttachmentType={setAttachmentType}
          deleteAttachment={deleteAttachment}
          showCaseDecisionDetailsPage={showCaseDecisionDetailsPage}
          updateCaseDecision={updateCaseDecision}
          courtCase={courtCase}
          canEdit={canEdit}
          mainAttachment={mainAttachment}
          toggleAttachementModal={toggleAttachementModal}
          attachmentModalVisible={attachmentModalVisible}
          anonimisedUploadedFile={anonimisedUploadedFile}
          setAnonymisedFileValue={setAnonymisedFileValue}
          parentGroupList={parentGroupList}
          secondGroupList={secondGroupList}
          selectedParentGroupIdList={selectedParentGroupIdList}
          selectedSecondGroupIdList={selectedSecondGroupIdList}
          setParentGroupId={setParentGroupId}
          setSecondGroupId={setSecondGroupId}
          organisationIndexes={organisationIndexes}
          selectedIndexes={selectedIndexes}
          publishCaseDecision={publishCaseDecision}
          setMainAttachmentType={setMainAttachmentType}
          indexTypeAttributes={indexTypeAttributes}
          setAttributesData={setAttributesData}
          indexAttributeDataList={indexAttributeDataList}
          closeIndexDataModal={closeIndexDataModal}
          openIndexDataModal={openIndexDataModal}
          indexDataModalVisible={indexDataModalVisible}
          saveAttributeData={saveAttributeData}
          selectedIndexForAttribute={selectedIndexForAttribute}
        />
      </Page>
    );
  }
}
